export default "__VITE_ASSET__BKjtmVWr__"